import { currentLanguage } from './translations.js';

// Contact form functionality
let contactFormData = {};
let contactFormStep = 0;
const contactFormSteps = ['name', 'email', 'telegram'];

export function startContactForm() {
	contactFormData = {};
	contactFormStep = 0;

	const terminalContent = document.querySelector('.terminal-content');

	// Remove the regular command line that triggered this command
	const regularCommandLine = terminalContent.querySelector(
		'.command-line:not(.contact-form)'
	);
	if (regularCommandLine) {
		regularCommandLine.remove();
	}
	const messageDiv = document.createElement('div');
	messageDiv.style.cssText = `
        color: var(--neon-green);
        margin-top: 5px;
        margin-bottom: 10px;
    `;

	const startMessage =
		currentLanguage === 'ru'
			? 'Началось заполнение формы контакта. Для отмены введи "cancel" в любой момент.'
			: 'Starting contact form. Type "cancel" at any time to cancel.';

	messageDiv.textContent = startMessage;

	// Insert before the current command line
	const currentCommandLine = terminalContent.querySelector('.command-line');
	if (currentCommandLine) {
		terminalContent.insertBefore(messageDiv, currentCommandLine);
	} else {
		terminalContent.appendChild(messageDiv);
	}

	// Start asking for the first field after a delay
	setTimeout(() => {
		askNextField();
	}, 500);
}

function askNextField() {
	const terminalContent = document.querySelector('.terminal-content');

	// Remove old contact form command line if exists
	const oldContactForm = terminalContent.querySelector(
		'.command-line.contact-form'
	);
	if (oldContactForm) {
		oldContactForm.remove();
	}

	const currentField = contactFormSteps[contactFormStep];
	let question = '';
	let placeholder = '';

	if (currentLanguage === 'ru') {
		switch (currentField) {
			case 'name':
				question = 'Введи имя:';
				placeholder = 'Ваше имя';
				break;
			case 'email':
				question = 'Введи email:';
				placeholder = 'example@domain.com';
				break;
			case 'telegram':
				question = 'Введи Telegram юзернейм, опционально:';
				placeholder = '@username или оставьте пустым';
				break;
		}
	} else {
		switch (currentField) {
			case 'name':
				question = 'Enter name:';
				placeholder = 'Your name';
				break;
			case 'email':
				question = 'Enter email:';
				placeholder = 'example@domain.com';
				break;
			case 'telegram':
				question = 'Enter Telegram username, optional:';
				placeholder = '@username or leave empty';
				break;
		}
	}

	// Create question prompt
	const questionDiv = document.createElement('div');
	questionDiv.style.cssText = `
        color: var(--electric-blue);
        margin-top: 10px;
        margin-bottom: 5px;
    `;
	questionDiv.textContent = question;
	terminalContent.appendChild(questionDiv);

	// Create new command line for input
	const commandLineContainer = document.createElement('div');
	commandLineContainer.className = 'command-line contact-form';
	commandLineContainer.style.marginTop = '5px';

	const prompt = document.createElement('div');
	prompt.className = 'prompt';
	prompt.innerHTML = `
        <span class="user" style="color: var(--electric-blue);">contact</span>
        <span class="separator" style="color: var(--white);">:</span>
        <span class="path" style="color: var(--cyber-pink);">${currentField}</span>
        <span class="dollar" style="color: var(--neon-green); margin: 0 8px 0 4px;">$</span>
    `;

	// Create input field
	const input = document.createElement('input');
	input.type = 'text';
	input.className = 'command-input contact-input';
	input.autocomplete = 'new-password';
	input.autocapitalize = 'off';
	input.autocorrect = 'off';
	input.spellcheck = false;
	input.setAttribute('data-form-type', 'other');
	input.setAttribute('data-lpignore', 'true');
	input.name = 'contact_' + Math.random().toString(36).substr(2, 9);
	input.setAttribute('readonly', 'readonly');
	setTimeout(() => input.removeAttribute('readonly'), 100);
	input.placeholder = placeholder;
	input.style.cssText = `
        background: transparent;
        border: none;
        outline: none;
        color: var(--white);
        font-family: 'Fira Code', monospace;
        font-size: 14px;
        width: 300px;
        caret-color: var(--neon-green);
    `;

	prompt.appendChild(input);
	commandLineContainer.appendChild(prompt);
	terminalContent.appendChild(commandLineContainer);

	// Handle input
	input.addEventListener('keydown', e => {
		if (e.key === 'Enter') {
			const value = e.target.value.trim();

			// Check for cancel
			if (value.toLowerCase() === 'cancel') {
				cancelContactForm();
				return;
			}

			// Validate required fields
			if (currentField !== 'telegram' && value === '') {
				const errorMsg =
					currentLanguage === 'ru'
						? 'Это поле обязательно для заполнения!'
						: 'This field is required!';
				showFormError(errorMsg);
				return;
			}

			// Validate email
			if (currentField === 'email' && value !== '') {
				const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				if (!emailRegex.test(value)) {
					const errorMsg =
						currentLanguage === 'ru'
							? 'Введите корректный email адрес!'
							: 'Please enter a valid email address!';
					showFormError(errorMsg);
					return;
				}
			}

			// Save the value
			contactFormData[currentField] = value;

			// Show the entered value
			showEnteredValue(currentField, value);

			// Move to next step
			contactFormStep++;

			if (contactFormStep >= contactFormSteps.length) {
				// All data collected, send to Telegram
				sendToTelegram();
			} else {
				// Ask for next field
				setTimeout(() => {
					askNextField();
				}, 500);
			}
		}
	});

	// Focus input
	input.focus();

	// Scroll to bottom
	terminalContent.scrollTop = terminalContent.scrollHeight;
}

function showEnteredValue(field, value) {
	const terminalContent = document.querySelector('.terminal-content');
	const valueDiv = document.createElement('div');
	valueDiv.style.cssText = `
        color: var(--white);
        margin-top: 5px;
        margin-bottom: 10px;
    `;

	const displayValue =
		value === ''
			? currentLanguage === 'ru'
				? '(пропущено)'
				: '(skipped)'
			: value;
	valueDiv.innerHTML = `
        <span style="color: var(--electric-blue);">contact</span>
        <span style="color: var(--white);">:</span>
        <span style="color: var(--cyber-pink);">${field}</span>
        <span style="color: var(--neon-green);">$</span>
        <span style="color: var(--white); margin-left: 8px;">${displayValue}</span>
    `;

	// Insert before the current command line
	const currentCommandLine = terminalContent.querySelector('.command-line');
	if (currentCommandLine) {
		terminalContent.insertBefore(valueDiv, currentCommandLine);
	} else {
		terminalContent.appendChild(valueDiv);
	}
}

function showFormError(errorMsg) {
	const terminalContent = document.querySelector('.terminal-content');
	const errorDiv = document.createElement('div');
	errorDiv.style.cssText = `
        color: var(--cyber-pink);
        margin-top: 5px;
        margin-bottom: 10px;
    `;
	errorDiv.textContent = errorMsg;

	// Insert before the current command line
	const currentCommandLine = terminalContent.querySelector('.command-line');
	if (currentCommandLine) {
		terminalContent.insertBefore(errorDiv, currentCommandLine);
	} else {
		terminalContent.appendChild(errorDiv);
	}
}

function cancelContactForm() {
	const terminalContent = document.querySelector('.terminal-content');

	// Remove contact form command line
	const contactForm = terminalContent.querySelector(
		'.command-line.contact-form'
	);
	if (contactForm) {
		contactForm.remove();
	}

	// Show cancellation message
	const cancelDiv = document.createElement('div');
	cancelDiv.style.cssText = `
        color: var(--cyber-pink);
        margin-top: 5px;
        margin-bottom: 10px;
    `;
	cancelDiv.textContent =
		currentLanguage === 'ru'
			? 'Заполнение формы отменено.'
			: 'Contact form cancelled.';
	terminalContent.appendChild(cancelDiv);

	// Create new regular command line
	setTimeout(() => {
		window.commandLineModule.initInteractiveCommandLine();
	}, 500);
}

async function sendToTelegram() {
	const terminalContent = document.querySelector('.terminal-content');

	// Remove contact form command line
	const contactForm = terminalContent.querySelector(
		'.command-line.contact-form'
	);
	if (contactForm) {
		contactForm.remove();
	}

	// Show sending message
	const sendingDiv = document.createElement('div');
	sendingDiv.style.cssText = `
        color: var(--electric-blue);
        margin-top: 10px;
        margin-bottom: 10px;
    `;
	sendingDiv.textContent =
		currentLanguage === 'ru'
			? 'Отправка сообщения...'
			: 'Sending message...';
	terminalContent.appendChild(sendingDiv);

	// Prepare message for Telegram
	const { name, email, telegram } = contactFormData;
	const telegramText = telegram && telegram !== '' ? telegram : 'не указан';

	const message = `🤖 Новое сообщение с портфолио!

👤 Имя: ${name}
📧 Email: ${email}
💬 Telegram: ${telegramText}

📅 Дата: ${new Date().toLocaleString('ru-RU')}`;

	const botToken = '6021023621:AAE1UuSHsN82EspCiezfTl_5MLnOPuCJjzE';
	const chatId = '5353106736';

	try {
		const response = await fetch(
			`https://api.telegram.org/bot${botToken}/sendMessage`,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					chat_id: chatId,
					text: message,
					parse_mode: 'HTML',
				}),
			}
		);

		const result = await response.json();

		// Remove sending message
		sendingDiv.remove();

		if (result.ok) {
			// Success message
			const successDiv = document.createElement('div');
			successDiv.style.cssText = `
                color: var(--neon-green);
                margin-top: 5px;
                margin-bottom: 10px;
            `;
			successDiv.textContent =
				currentLanguage === 'ru'
					? '✅ Сообщение успешно отправлено! Скоро я свяжусь с тобой.'
					: '✅ Message sent successfully! I will contact you soon.';
			terminalContent.appendChild(successDiv);
		} else {
			throw new Error(result.description || 'Failed to send message');
		}
	} catch (error) {
		console.error('Error sending to Telegram:', error);

		// Remove sending message
		sendingDiv.remove();

		// Error message
		const errorDiv = document.createElement('div');
		errorDiv.style.cssText = `
            color: var(--cyber-pink);
            margin-top: 5px;
            margin-bottom: 10px;
        `;
		errorDiv.textContent =
			currentLanguage === 'ru'
				? '❌ Ошибка при отправке сообщения. Попробуй позже или свяжись напрямую.'
				: '❌ Error sending message. Please try again later or contact directly.';
		terminalContent.appendChild(errorDiv);
	}

	// Create new command line after a delay
	setTimeout(() => {
		window.commandLineModule.initInteractiveCommandLine();
	}, 2000);
}